/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";

export type V1ApiKeysListKeysRequestBody = {
  /**
   * Maximum number of readable API keys per page.
   */
  limit?: number | undefined;
  /**
   * Opaque cursor from a previous response. Omit for the first page.
   */
  cursor?: string | undefined;
};

/** @internal */
export type V1ApiKeysListKeysRequestBody$Outbound = {
  limit: number;
  cursor?: string | undefined;
};

/** @internal */
export const V1ApiKeysListKeysRequestBody$outboundSchema: z.ZodType<
  V1ApiKeysListKeysRequestBody$Outbound,
  z.ZodTypeDef,
  V1ApiKeysListKeysRequestBody
> = z.object({
  limit: z.number().int().default(100),
  cursor: z.string().optional(),
});

export function v1ApiKeysListKeysRequestBodyToJSON(
  v1ApiKeysListKeysRequestBody: V1ApiKeysListKeysRequestBody,
): string {
  return JSON.stringify(
    V1ApiKeysListKeysRequestBody$outboundSchema.parse(
      v1ApiKeysListKeysRequestBody,
    ),
  );
}
